import type { InternalHost } from '../host';
import type { Metadata } from '../xinglet';
import { useHost } from './use-host';

export function useMetadata(name: string): Metadata {
  const host = useHost<InternalHost>();

  return host.runtime.metadata[name];
}
